export type DeprecatedCustomerOptimizeRoutePageId =
  | "flexsave-aws-2"
  | "flexsave-kubernetes-2"
  | "insights-2"
  | "insights:newInsight-2"
  | "insights:details-2"
  | "spot-scaling-2"
  | "spot-scaling:apply-2";

export type DeprecatedCustomerOptimizeRouteConfig = {
  pageId: DeprecatedCustomerOptimizeRoutePageId;
  route: string;
};

export const deprecatedCustomerOptimizeRoutes: DeprecatedCustomerOptimizeRouteConfig[] = [
  {
    pageId: "flexsave-aws-2",
    route: "/flexsave-aws",
  },
  {
    pageId: "flexsave-kubernetes-2",
    route: "/flexsave-kubernetes",
  },
  {
    pageId: "insights-2",
    route: "/insights",
  },
  {
    pageId: "insights:newInsight-2",
    route: "/insights/new-insight/:insightKey?",
  },
  {
    pageId: "insights:details-2",
    route: "/insights/:providerId/:insightKey",
  },
  {
    pageId: "spot-scaling-2",
    route: "/spot-scaling",
  },
  {
    pageId: "spot-scaling:apply-2",
    route: "/spot-scaling/:asgName",
  },
];
